import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTransportAccess } from '@/hooks/use-transport-access';
import LoadingFallback from '@/components/LoadingFallback';

interface TransportAccessGuardProps {
  children: ReactNode;
}

export const TransportAccessGuard = ({ children }: TransportAccessGuardProps) => {
  const { canViewTransportNav, isLoading } = useTransportAccess();

  if (isLoading) {
    return <LoadingFallback />;
  }

  if (!canViewTransportNav) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};
